"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDTH = exports.TITLE_TEXT_STYLE = exports.TITLE_TEXT = exports.TEXT = void 0;
var TITLE_TEXT = 'SNAP (Flights + Hotel)';
exports.TITLE_TEXT = TITLE_TEXT;
var TEXT = 'Check out the savings you get when adding a hotel';
exports.TEXT = TEXT;
var WIDTH = '200px';
exports.WIDTH = WIDTH;
var TITLE_TEXT_STYLE = {
  COLOR: 'default',
  TYPE: 'sub',
  OFFSET_TOP: '-11px'
};
exports.TITLE_TEXT_STYLE = TITLE_TEXT_STYLE;